import { useUser } from '../contexts/UserContext'
import { permissionType } from '../utils/constants'

export const useCustomizeUI = () => {
  const { canAccess } = useUser()

  const canEditCheckoutCoreSetup = canAccess(permissionType.CORE_SETUP_CHECKOUT_EDIT, 0)
  const canEditBrandDetails = canAccess(permissionType.BRAND_DETAILS_CHECKOUT_EDIT, 0)
  const canEditLoginPage = canAccess(permissionType.LOGIN_PAGE_CHECKOUT_EDIT, 0)
  const canEditCouponsPage = canAccess(permissionType.COUPONS_PAGE_CHECKOUT_EDIT, 0)
  const canEditAddressPage = canAccess(permissionType.ADDRESS_PAGE_EDIT, 0)
  const canEditPaymentsPage = canAccess(permissionType.PAYMENTS_PAGE_EDIT, 0)

  return {
    canEditCheckoutCoreSetup,
    canEditBrandDetails,
    canEditLoginPage,
    canEditCouponsPage,
    canEditAddressPage,
    canEditPaymentsPage
  }
}
